import React, { useState, useEffect } from "react";
import { Link, useNavigate } from "react-router-dom";
import {jwtDecode} from "jwt-decode";  // Removido as chaves do import
import { DataTable } from "primereact/datatable";
import { Column } from "primereact/column";
import { Button } from "primereact/button";
import { useLanguage } from "context/LanguageContext";
import "./styleds.scss";

const Home = () => {
  const { GetTranslation } = useLanguage();
  const [records, setRecords] = useState([]);
  const [uniqueColumns, setUniqueColumns] = useState([]);
  const navigate = useNavigate();

  // Função para transformar os dados em um formato adequado para o DataTable
  const TransformData = (data) => {
    const records = {};
    const uniqueColumns = new Set();
  
    data.forEach((item) => {
      console.log(item);
      // Adiciona as colunas únicas
      uniqueColumns.add("cpf");
      uniqueColumns.add("hospital");
      uniqueColumns.add("nome");
  
      // Cria o registro se ainda não existir
      if (!records[item.id]) {
        records[item.id] = { id: item.id };
      }
  
      // Adiciona os valores do registro
      records[item.id]["cpf"] = item.cpf;
      records[item.id]["hospital"] = item.hospital;
      records[item.id]["nome"] = item.nome;
    });
  
    return {
      transformedData: Object.values(records), // Transforma o objeto em um array de registros
      uniqueColumns: Array.from(uniqueColumns) // Transforma o Set em um array de colunas únicas
    };
  };

  const StateData = (token) => {
    // Decodifica o token JWT para obter o user_id do usuário logado
    const decodedToken = jwtDecode(token);

    // Busca os registros da tabela de identificação relacionados ao usuário logado
    fetch(`${process.env.REACT_APP_API_URL}/identificacao/pacientes`, {
      method: "GET",
      headers: {
        "Content-Type": "application/json",
        Authorization: `Bearer ${token}`
      }
    })
      .then((response) => response.json())
      .then((data) => {
        const { transformedData, uniqueColumns } = TransformData(data);
        setRecords(transformedData);
        setUniqueColumns(uniqueColumns);
      })
      .catch((error) => console.error("Error fetching identification records:", error));
  };

  useEffect(() => {
    const token = localStorage.getItem("token");

    // Verifica se o token existe
    if (!token) {
      navigate("/"); // Redireciona para a página inicial se não houver token
      return;
    } else {
      StateData(token);
    }
  }, []); // Recarrega quando institutions mudar

  return (
    <div className="card p-3 registros">
      <div className="d-flex flex-wrap justify-content-between align-items-center gap-3 mb-3">
        <h1>{GetTranslation("Records")}</h1>
        <div className="d-flex flex-row gap-3">
          <Button
            label={GetTranslation("Criar_Paciente")}
            onClick={() => navigate("/app/form/identificacao")}
          />
        </div>
      </div>
      <DataTable value={records} emptyMessage ={() => "Nenhuma opção disponível"}>
        <Column field="hospital" header={GetTranslation("hospital")} />
        <Column field="nome" header={GetTranslation("Nome")} />
        <Column field="cpf" header="CPF" />
        <Column
          body={(rowData) => (
            <Link
              to={`/app/categoria/${rowData.id}`}
              className="btn-link-tabela"
            >
              <i className="pi pi-search"></i>
            </Link>
          )}
          header={GetTranslation("Details")}
        />
      </DataTable>
    </div>
  );
};

export default Home;
